<template>
	<div class="homework-textarea homework-seo">
		<div v-if="answerClassification.length > 2" class="homework-item-txt">{{answerClassification}}</div>
		<el-form-item label="标题：">
			<el-input v-model="dataSeo.seoTitle" placeholder="请输入标题" :maxlength="80" show-word-limit></el-input>
		</el-form-item>
		<el-form-item label="关键词：">
			<el-input v-model="dataSeo.seoKey" placeholder="请输入关键词" :maxlength="100" show-word-limit></el-input>
		</el-form-item>
		<el-form-item label="描述：">
			<el-input v-model="dataSeo.seoDesc" placeholder="请输入描述"  type="textarea" rows="3"  :maxlength="200" show-word-limit></el-input>
		</el-form-item>
	</div>
</template>

<script>
export default {
	name: 'formItemText',
	props: {
		answerClassification:String,
		value: String,
		lineNumber: Number,
		restrict: String,
		count: Number,
	},
	watch: {
		dataSeo:{
			deep:true,
			handler:function(newV,oldV){
				this.$emit('input',`${newV.seoTitle || ''}@@${newV.seoKey || ''}@@${newV.seoDesc || ''}`  )
			}
		},
	},
	created(){
		if(!this.value) return
		const seoInfo = this.value.split('@@')
		this.dataSeo.seoTitle = seoInfo[0]
		this.dataSeo.seoKey = seoInfo[1]
		this.dataSeo.seoDesc = seoInfo[2]
	},
	data() {
		return {
			// textValue:
			dataSeo: {
				seoTitle:'',
				seoKey:'',
				seoDesc:''
			},

		}
	},
}
</script>

<style lang="scss" scoped>
.homework-item-txt{

		font-size: 16px;
		font-weight: bold;
		line-height: 20px;
		color: #666666;
		z-index: 99;
		margin-bottom: 10px;
	}
.homework-textarea{
	position: relative;
	margin: 10px 20px 0;
	input{
		border: 1px solid  #C0C4CC;;
	}
}
</style>
